import React from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import PartsDealerBrandMatchForm from './components/PartsDealerBrandMatchForm';
import PartsDealerBrandMatchTable from './components/PartsDealerBrandMatchTable';
import usePartsDealerBrandMatch from './hooks/usePartsDealerBrandMatch';
import { useLanguage } from '../../../contexts/LanguageContext';

const PartsDealerBrandMatchPage = () => {
    const { th } = useLanguage();
    const { toast, tableProps, formProps, openNewDialog, refetchList, deleteConfirmationVisible, setDeleteConfirmationVisible, deleteItem } = usePartsDealerBrandMatch();

    return (
        <div className="card">
            <Toast ref={toast} />
            <ConfirmDialog
                visible={deleteConfirmationVisible}
                onHide={() => setDeleteConfirmationVisible(false)}
                message={th('partsDealerBrandMatch.deleteConfirm')}
                header={th('common.confirm')}
                icon="pi pi-exclamation-triangle"
                accept={deleteItem}
                reject={() => setDeleteConfirmationVisible(false)}
                acceptLabel={th('common.yes')}
                rejectLabel={th('common.no')}
            />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('partsDealerBrandMatch.title')}</h1>
                <div className="flex gap-2">
                    <Button label={th('common.refreshList')} icon="pi pi-refresh" outlined onClick={() => refetchList()} loading={tableProps.isLoading} />
                    <Button label={th('common.new')} icon="pi pi-plus" onClick={openNewDialog} />
                </div>
            </div>

            <PartsDealerBrandMatchForm {...formProps} />

            <PartsDealerBrandMatchTable {...tableProps} />
        </div>
    );
};

export default PartsDealerBrandMatchPage;
